import store from '@/store'

export default {
  before: {
    all: context => {
      const { token } = store.state.auth
      if (token) {
        context.params.token = token
      }
      return context
    }
  }
}
